class ProductTemplate extends HTMLElement {
  constructor() {
    super();

    this.calculateShipping();
    this.swiperInit();
  }

  calculateShipping() {
    if (this.querySelector(".product-form__icon")) {
      // calculate shipping date from today + shipping delay exclude weekends
      let shipping_date = new Date(new Date().getTime());

      for (var i = 0; i < shipping_delay; i++) {
        shipping_date.setDate(shipping_date.getDate() + 1);
        if (shipping_date.getDay() == 6) {
          shipping_date.setDate(shipping_date.getDate() + 2);
        }
        if (shipping_date.getDay() == 0) {
          shipping_date.setDate(shipping_date.getDate() + 1);
        }
      }

      // get french date format day month year
      let shipping_date_format = shipping_date.toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      for (
        let i = 0;
        i < document.querySelectorAll(".product-form__icon").length;
        i++
      ) {
        let html = document.querySelectorAll(".product-form__icon")[i]
          .innerHTML;
        if (html.indexOf("[date]") > -1) {
          document.querySelectorAll(".product-form__icon")[i].innerHTML =
            html.replace("[date]", shipping_date_format);
        }
      }
    }
  }

  swiperInit() {
    this.swiper = new Swiper(".product-medias__thumbnail--main", {
      slidesPerView: 5,
      spaceBetween: 8,
      direction: "horizontal",
      allowTouchMove: true,
      loopPreventsSlide: false,
      edgeSwipeDetection: "prevent",
      preventClicks: true,
      preventClicksPropagation: true,
      touchMoveStopPropagation: false,
      a11y: false,
      speed: 400,
      threshold: 15,
      touchStartForcePreventDefault: false,

      breakpoints: {
        360: {
          spaceBetween: 15,
        },
      },
    });

    this.swiper2 = new Swiper(".product-medias__main--main", {
      allowTouchMove: true,
      threshold: 10,
      thumbs: {
        swiper: this.swiper,
        autoScrollOffset: 0,
        thumbsContainerClass: "thumbs-container",
      },
      noSwipingClass: "swiper-no-swiping",
      breakpoints: {
        1140: {
          allowTouchMove: false,
        },
      },
      navigation: {
        nextEl: ".products-thumb-v2__next ",
        prevEl: ".products-thumb-v2__prev ",
      },
    });

    this.swiper2.on("slideChange", this.updateSlide.bind(this));
  }

  updateSlide() {}
}

customElements.define("product-template", ProductTemplate);

function findGetParameter(parameterName) {
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.is_subscription = false;
    this.base_url = this.dataset.url;
    this.addEventListener("change", this.onVariantChange);

    if (findGetParameter("discover") == "true") {
      setTimeout(function () {
        document.querySelector('[value="7 sachets ( 1 de chaque )"]').click();
      }, 400);
    }
  }

  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();

    this.find_merged =
      merged_variants && merged_variants.length > 0
        ? merged_variants.find((item) => item.id == this.currentVariant.id)
        : null;

    if (this.find_merged) {
      this.dataset.url = merged_url;
    } else {
      this.dataset.url = this.base_url;
    }
    if (this.currentVariant) {
      this.updateURL();
      this.updateFormID();
      this.updatePriceAndCTA();
    }

    console.log(this.currentVariant);

    if (this.find_merged) {
      document
        .querySelector(".product-pack__recurring")
        .classList.add("hidden");
      document
        .querySelector('subscription-option[data-subscribe="false"]')
        .click();
      return;
    }

    document
      .querySelector(".product-pack__recurring")
      .classList.remove("hidden");
  }

  getSelectedOptions() {
    this.options = Array.from(
      this.querySelectorAll(".mm-product-variant-checkbox:checked"),
      (checkbox) => checkbox.value
    );
  }

  getVariantJSON() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);

      if (findings) return variant;
    });

    //console.log(this.currentVariant);
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.base_url}?variant=${this.currentVariant.id}`
    );
  }

  updateFormID() {
    const form_input = document
      .querySelector("#product-form")
      .querySelector('input[name="id"]');
    form_input.value = this.currentVariant.id;
  }

  updatePriceAndCTA() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const idCTA = `cta-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const oldPrice = document.getElementById(id);
        const newPrice = html.getElementById(id);
        console.log(newPrice);
        const oldCTA = document.getElementById(idCTA);
        const newCTA = html.getElementById(idCTA);

        let unit_price_source = document.querySelector(
          `#shopify-section-${this.dataset.section} .unit-price`
        );
        let unit_price = html.querySelector(".unit-price");

        let unit_price_sub_source = document.querySelector(
          `#shopify-section-${this.dataset.section} .unit-price-sub`
        );
        let unit__sub_price = html.querySelector(".unit-price-sub");

        if (unit_price_source && unit_price) {
          unit_price_source.innerHTML = unit_price.innerHTML;
        }

        if (unit_price_sub_source && unit__sub_price) {
          unit_price_sub_source.innerHTML = unit__sub_price.innerHTML;
        }

        if (oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;
        if (oldCTA && newCTA) oldCTA.innerHTML = newCTA.innerHTML;

        let sub_price = document.querySelector("[data-subscription-price]");
        let oneshot_price1 = document.querySelector("[data-oneshot-price]");

        let current_price = parseFloat(this.currentVariant.price) / 100;

        oneshot_price1.innerHTML = current_price.toFixed(2);

        let current_price_sub =
          current_price *
          document.querySelector("[data-discount]").dataset.discount;
        sub_price.innerHTML = current_price_sub.toFixed(2);

        if (sub_price && oneshot_price1) {
          // let discount = parseFloat(
          //   document.querySelector("[data-discount]").dataset.discount
          // );

          // console.log(newPrice);

          // let p1 = parseFloat(
          //   newPrice
          //     .querySelector(".mm-product-price")
          //     .innerHTML.replace("€", "")
          //     .replace(",", ".")
          // );

          // sub_price.innerHTML = "€" + p1 * discount;

          //     .toFixed(2)
          //     .replace(".", ",");
          // oneshot_price1.innerHTML = newPrice.querySelector(
          //   ".mm-dc-product-price"
          // ).innerHTML;
          // oneshot_price = document
          //   .querySelector("[data-oneshot-price]")
          //   .innerHTML.replace("€", "")
          //   .replace(",", ".");
          updateAllPrices();
        }
        initAddToCart();

        let price = document.querySelector(
          "#mm-add-to-cart-container .mm-product-price"
        );
        if (price) {
          document.querySelector(
            ".product-form__header .mm-product-price"
          ).innerHTML = price.innerHTML;
        }
      });
  }
}

customElements.define("variant-selector", VariantSelector);
